import { render, staticRenderFns } from "./number.vue?vue&type=template&id=2695bbc7&scoped=true&"
import script from "./number.js?vue&type=script&lang=js&"
export * from "./number.js?vue&type=script&lang=js&"
import style0 from "./number.css?vue&type=style&index=0&id=2695bbc7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2695bbc7",
  null
  
)

export default component.exports